import React from "react";
import { Toaster } from "react-hot-toast";
import PageTitle from "./components/PageTitle";
import AppHeader from "./components/AppHeader";
import AppContent from "./components/AppContent";

function App() {
  return (
    <>
      <div className="w-[100%] m-auto max-w-[1200px] bg-gradient-to-r from-blue-300 to-white">
        <PageTitle>To-Do Tracker </PageTitle>
        <div className="max-w-750 w-full mx-auto">
          <AppHeader />
          <AppContent />
        </div>
        </div>
        <Toaster
          toastOptions={{
            style: {
              fontSize: "1.4rem",
            },
          }}
        />
    </>
  );
}

export default App;
